export default "__VITE_ASSET__NxRJQ_EL__"